import NominalRoleLayout from '../components/organisms/NominalRoleLayout';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useState, useEffect } from 'react';
import config from '../config';

const NominalRole = () => {
  const { levelSelection } = useParams();
  const [dataRow, setDataRow] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const nomRoleData = new FormData();
    nomRoleData.append('mode', 'getNominalRoleForLevel');
    nomRoleData.append('level', levelSelection);
    nomRoleData.append('auth', localStorage.getItem('token'));

    axios.post(config.STUDENTS_API, nomRoleData).then(output => {
      if (output.data.response.status === 'OK') {
        setDataRow(output.data.response.data);
        setLoading(false);
      }
    });
  }, []);

  const colDef = (field, headerName, width = 100) => {
    return {
      field,
      headerName,
      width,
      headerClassName: 'bg-primary-100 text-md font-bold',
    };
  };
  const columns = [
    colDef('sn', 'SN', 50),
    colDef('id', 'UID', 80),
    colDef('bc_name', 'ID Name', 150),
    colDef('first_name', 'First Name', 150),
    colDef('last_name', 'Last Name', 150),
    colDef('gender', 'Gender', 60),
    colDef('dob', 'Date Of Birth', 110),
    colDef('student_mobile', 'Mobile', 110),
    colDef('baptism_date', 'Baptism Date', 110),
    colDef('baptism_church', 'Church Of Baptism', 200),
    colDef('address', 'Residential Address', 180),
    colDef('address_unit', 'Unit No', 110),
    colDef('address_postal', 'Postal Code', 90),
    colDef('session', 'Session', 150),
    colDef('school', 'School', 120),
    colDef('school_level', 'School Level', 90),
    colDef('primary_parent_name', 'Primary Contact', 150),
    colDef('primary_relationship', 'Relationship', 90),
    colDef('primary_mobile', 'Primary Mobile'),
    colDef('primary_email', 'Email', 150),
    colDef('primary_religion', 'Religion', 110),
    colDef('sec_parent_name', 'Secondary Contact', 150),
    colDef('sec_relationship', 'Relationship', 90),
    colDef('sec_mobile', 'Secondary Mobile'),
    colDef('sec_email', 'Email', 150),
    colDef('sec_religion', 'Religion', 110),
  ];

  return (
    <NominalRoleLayout
      levelSelection={levelSelection}
      dataRow={dataRow}
      loading={loading}
      columns={columns}
    />
  );
};

export default NominalRole;
